import InputRC from "components/ui/forms/InputRC";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Button from "components/ui/Button";
import { useTranslation } from "react-i18next";

const TimeOut = () => {
  const { t } = useTranslation();
  const [isRadioValue, setIsRadioValue] = useState(false);

  const SUBSCRIBE_OPTIONS = [
    { value: "24hour", label: "24 hours" },
    { value: "oneweak", label: "One weak" },
    { value: "onemonth", label: "One month" },
    { value: "twomonth", label: "Two month" },
  ];
  const handleChange = (e) => {
    const timeOutValue = e.target.value;
    setIsRadioValue(timeOutValue);
  };
  return (
    <>
      <p className="sm:text-[rgb(255,255,255,.5)] text-[rgb(255,255,255,.5)] lg:text-[rgb(255,255,255,.8)] text-[12px] mb-4 lg:leading-[24px] leading-[1.25] lg:tracking-[.46px]">
        {t("timeOutInfoText")}
      </p>
      <ul className="my-1 py-2">
        {SUBSCRIBE_OPTIONS.map((item, index) => (
          <li key={index} className="flex mb-4 justify-between">
            <div className="text-sm flex gap-6">
              <InputRC
                type="radio"
                name="subscription"
                value={item.value}
                label={item.label}
                onChange={(e) => handleChange(e)}
                // register={register}
              />
            </div>
          </li>
        ))}
      </ul>
      <div className="bg-body w-full mt-3">
        <Button
          label={t("Save Changes")}
          type="submit"
          className={`uppercase md:max-w-[370px] w-full p-2 ${
            isRadioValue ? "bg-[rgb(16,145,33,1)] text-white text-[12px] cursor-pointer" : "bg-gray-300 text-gray-500 text-[12px]"
          }`}
          disabled={!isRadioValue}
        />
      </div>
    </>
  );
};
export default TimeOut;
